const COOKIE_LANG = "ff_lang";   // 'fr' | 'en'
const COOKIE_QC   = "ff_is_qc";  // '1' | '0'

export function setCookie(name, value, days) {
  if (typeof document === "undefined") return;
  const maxAge = days ? days * 24 * 60 * 60 : 365 * 24 * 60 * 60;
  document.cookie = `${name}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;
}

export function getCookie(name) {
  if (typeof document === "undefined" || !document.cookie) return null;
  const found = document.cookie
    .split(";")
    .map((s) => s.trim())
    .find((s) => s.startsWith(name + "="));
  return found ? decodeURIComponent(found.split("=").slice(1).join("=")) : null;
}

export function getSavedLang() {
  const v = getCookie(COOKIE_LANG);
  if (v === "fr" || v === "en") return v;
  try {
    const ls = localStorage.getItem(COOKIE_LANG);
    return ls === "fr" || ls === "en" ? ls : null;
  } catch {
    return null;
  }
}

export function saveLang(lang) {
  try {
    localStorage.setItem(COOKIE_LANG, lang);
  } catch {}
  setCookie(COOKIE_LANG, lang, 365);
}

export function isQcByCookie() {
  return getCookie(COOKIE_QC) === "1";
}

export function guessLangFromBrowser() {
  const al =
    (typeof navigator !== "undefined" && (navigator.language || "")) || "";
  return al.toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function getLangFromUrl() {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  const l = params.get("lang");
  return l === "fr" || l === "en" ? l : null;
}

export function setLangInUrl(lang) {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  params.set("lang", lang);
  const qs = params.toString();
  window.history.replaceState({}, "", `${window.location.pathname}?${qs}`);
}

export function withLang(path, lang) {
  try {
    if (!lang) return path;
    if (path.includes("?")) return `${path}&lang=${lang}`;
    return `${path}?lang=${lang}`;
  } catch {
    return path;
  }
}
